export const MD_WIDTH = 768;
export const LG_WIDTH = 1024;
